import React, { Component } from 'react';
import Icon from '../../../../components/icon/Icon';
import './tab.scss';

export default class Tab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: false,
      activeIndex: null
    };
  }

  onTabClick(index) {
    this.setState({
      showContent: true,
      activeIndex: index
    });
  }

  render() {
    const { showContent, activeIndex } = this.state;
    const data = this.props.data;
    const ContentComponent = (function () {
      const RsComponent = activeIndex !== null ? data[activeIndex].contentComponent : '';
      return typeof RsComponent !== 'string' ? <RsComponent {...data[activeIndex]} /> : RsComponent;
    }());
    const isLast = activeIndex === data.length - 1;
    const isFirst = activeIndex === 0;

    return (
      <div className={['tab', this.props.className].join(' ')}>
        <div className="tab-header">
          {
            data.map((item, index) => (
              <div className="tab-header-item" key={item.name}>
                <div
                  className={['tab-header-item-wrap', activeIndex === index ? 'active' : ''].join(' ')}
                  onClick={() => this.onTabClick(index)}
                >
                  {
                    item.icon ? <Icon icon={item.icon} /> : ''
                  }
                  {item.name}
                </div>
              </div>
            ))
          }
        </div>
        {
          showContent ? (
            <div
              className={`
                tab-content 
                ${isLast ? 'tab-content-last' : ''} 
                ${isFirst ? 'tab-content-first' : ''}
              `}
            >
              {ContentComponent}
            </div>
          ) : ''
        }
      </div>
    );
  }
}
